import { cn } from '../../lib/css/className/className';
import { StackGap } from '../Stack';

import { TabSize } from './types';

export const tabMenuCls = cn('TabMenu');

export const gapMap: Record<TabSize, StackGap> = {
    xs: '20',
    m: '24',
};
